import { Component, EventEmitter, Output } from '@angular/core';
import { FormsModule, ReactiveFormsModule, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { SharedService } from '../shared.service';
import { CommonModule } from '@angular/common';
import { NgxMaskDirective, provideNgxMask } from 'ngx-mask';
@Component({
  selector: 'app-confirmation-modal',
  standalone: true,
  imports: [ReactiveFormsModule, CommonModule, FormsModule, NgxMaskDirective],
  templateUrl: './confirmation-modal.component.html',
  styleUrl: './confirmation-modal.component.scss'
})
export class ConfirmationModalComponent {

  public mask: string = '000-000-0000';

  @Output() passEntry: EventEmitter<any> = new EventEmitter();
  extra_data: modal_data = {
    label: '',
    hideNotes: false,
    modal_heading: '',
    data: [],
    confirmationType: true,
    type: '',
  };
  notesForm!: UntypedFormGroup;
  resendLinkForm!: UntypedFormGroup;
  reasons = ['The customer opted for a different platform', 'The customer changed their mind', 
    'A revised proposal has been sent','Services have been modified','This is a test proposal', 'Other' 
   ];
  constructor(public bsModalRef: BsModalRef, private _fb: UntypedFormBuilder, public _shared: SharedService) {
    
    this.notesForm = this._fb.group({
      notes: '',
      reason: '',
      other_reason: ''
    });
  }

  ngOnInit(): void {
    if (!this.extra_data.confirmationType) {
      this.resendLinkForm = this._fb.group({
        user_phone1: [(this.extra_data.data && this.extra_data.data['patient_mobile'] ? this.extra_data.data['patient_mobile'] : ''), [Validators.required]],
        user_email1: [(this.extra_data.data && this.extra_data.data['patient_email'] ? this.extra_data.data['patient_email'] : ''), [Validators.email, Validators.required]]
      })
    }
  }


  hide() {
    this.passEntry.emit({ success: false });
    this.bsModalRef.hide()
  }

  onSubmit() {
    if (this.resendLinkForm.invalid) {
      this.resendLinkForm.markAsDirty();
      this.resendLinkForm.markAllAsTouched();
      return;
    }
    // this.passEntry.emit({validForm: true, formValue: this.resendLinkForm.value,contract :this.extra_data.contract});
    this.hide();
  }


  confirm() {
    if (!this.extra_data.hideNotes && (!this.notesForm.value.notes || (this.notesForm.value.notes && !this.notesForm.value.notes.trim()))) {
      this._shared.customPopups('Please enter valid notes', 1);
      return;
    }
    const respObj: any = { success: true, notes: this.notesForm.value.notes };
    if (this.extra_data.type == 'delete_proposal'){
      if(!this.notesForm.value.reason) return this._shared.customPopups("Please select a valid reason", 1);
      if((!this.notesForm.value.other_reason || !this.notesForm.value.other_reason.trim()) && this.notesForm.value.reason == 5) return this._shared.customPopups("Please enter a valid reason", 1  );
      respObj['reason'] = this.notesForm.value.reason;
      if (this.notesForm.value.reason == 5){
        respObj['other_reason'] = this.notesForm.value.other_reason;
      }
    }
    this.passEntry.emit(respObj);
    this.hide();
  }

  changeReason(event: any) {
    this.notesForm.controls['reason'].setValue(event?.target?.value);
    if (event?.target?.value != 5){
      this.notesForm.controls['other_reason'].setValue('');
    }
  }
}

interface modal_data {
  label: string,
  hideNotes?: boolean,
  modal_heading?: string,
  confirmationType?: boolean,
  data?: any,
  type?: string,
  // Override the default Yes/No footer buttons.
  confirm_label?: string,
  cancel_label?: string,
}
